"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { Users, BookOpen, Globe } from "lucide-react";
const HERO_GRAIN_STYLE = `
  .council-hero-grain::after {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.06'/%3E%3C/svg%3E");
    pointer-events: none;
    z-index: 10;
  }
`;
export default function GoverningCouncilHero(t0) {
  const $ = _c(25);
  const {
    totalMembers: t1
  } = t0;
  const totalMembers = t1 === undefined ? 4 : t1;
  const t2 = `${totalMembers}`;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      icon: Users,
      label: "Council Members",
      value: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      icon: Globe,
      label: "Global Scope",
      value: "International"
    };
    t5 = {
      icon: BookOpen,
      label: "Mission",
      value: "Preservation"
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t3) {
    t6 = [t3, t4, t5];
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const stats = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <style>{HERO_GRAIN_STYLE}</style>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t10;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      scale: 1.05,
      opacity: 0
    };
    t9 = {
      scale: 1,
      opacity: 0.3
    };
    t10 = {
      duration: 1.5,
      ease: "easeOut"
    };
    $[7] = t10;
    $[8] = t8;
    $[9] = t9;
  } else {
    t10 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <motion.div initial={t8} animate={t9} transition={t10} className="absolute inset-0 z-0 pointer-events-none"><img src="/home/banner-hero.webp" alt="Governing Council of the Global Girmitiya Council" className="w-full h-full object-cover grayscale-[20%] sepia-[10%]" onError={_temp} /><div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E] via-[#0F1C2E]/80 to-[#0F1C2E]/40" /><div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-[#0F1C2E]/40 to-[#0F1C2E]" /></motion.div>;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  let t13;
  let t14;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: 0
    };
    t13 = {
      opacity: 0.04
    };
    t14 = {
      duration: 1.5,
      delay: 0.2
    };
    $[11] = t12;
    $[12] = t13;
    $[13] = t14;
  } else {
    t12 = $[11];
    t13 = $[12];
    t14 = $[13];
  }
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <motion.div initial={t12} animate={t13} transition={t14} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none z-10 w-full text-center"><span className="font-display text-[15vw] leading-none text-[#F4EFE6] whitespace-nowrap tracking-wider font-light uppercase">COUNCIL</span></motion.div>;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  let t17;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      opacity: 0,
      y: 20
    };
    t17 = {
      opacity: 1,
      y: 0
    };
    $[15] = t16;
    $[16] = t17;
  } else {
    t16 = $[15];
    t17 = $[16];
  }
  let t18;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      duration: 0.7,
      ease: [0.16, 1, 0.3, 1]
    };
    $[17] = t18;
  } else {
    t18 = $[17];
  }
  let t19;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <motion.div initial={t16} animate={t17} transition={t18} className="w-full lg:w-[58%]"><h1 className="font-display text-[34px] sm:text-[52px] md:text-[68px] lg:text-[76px] font-light leading-[1.05] text-[#F4EFE6] tracking-tight">Governing <em className="text-[#C9A84C] italic font-normal">Council</em></h1></motion.div>;
    $[18] = t19;
  } else {
    t19 = $[18];
  }
  let t20;
  let t21;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      opacity: 0,
      x: 15
    };
    t21 = {
      opacity: 1,
      x: 0
    };
    $[19] = t20;
    $[20] = t21;
  } else {
    t20 = $[19];
    t21 = $[20];
  }
  let t22;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      duration: 0.7,
      delay: 0.2,
      ease: [0.16, 1, 0.3, 1]
    };
    $[21] = t22;
  } else {
    t22 = $[21];
  }
  let t23;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <p className="font-body text-[13.5px] sm:text-[15px] md:text-[16px] font-light text-[#F4EFE6]/80 leading-[1.65]">Meet the visionary leaders and distinguished scholars guiding the Global Girmitiya Council in its mission to preserve the history, culture, and enduring legacy of the global Indian diaspora.</p>;
    $[22] = t23;
  } else {
    t23 = $[22];
  }
  let t24;
  if ($[23] !== stats) {
    t24 = <>{t7}<section className="relative bg-[#0F1C2E] text-[#F4EFE6] overflow-hidden py-20 sm:py-24 md:py-32 council-hero-grain">{t11}{t15}<div className="max-w-[1280px] mx-auto w-full px-4 sm:px-6 md:px-8 relative z-20"><div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 lg:gap-10">{t19}<motion.div initial={t20} animate={t21} transition={t22} className="w-full lg:w-[42%] border-l-2 border-[#DF6D2A]/40 pl-4 sm:pl-6 flex flex-col justify-between gap-4">{t23}<div className="grid grid-cols-3 gap-2 sm:gap-3 pt-3 border-t border-white/10">{stats.map(_temp2)}</div></motion.div></div></div></section></>;
    $[23] = stats;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  return t24;
}
function _temp2(stat, idx) {
  const Icon = stat.icon;
  return <div key={idx} className="flex flex-col"><div className="flex items-center gap-1 text-[#C9A84C] mb-0.5"><Icon size={13} className="flex-shrink-0" /><span className="font-display text-[16px] sm:text-[20px] font-semibold text-[#F4EFE6]">{stat.value}</span></div><span className="font-body text-[9.5px] sm:text-[10.5px] uppercase tracking-wider text-[#F4EFE6]/60">{stat.label}</span></div>;
}
function _temp(e) {
  e.target.onerror = null;
  e.target.src = "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?q=80&w=2000&auto=format&fit=crop";
}